import React from 'react';
import { Button } from 'js/components/common/Button';
import { LocalPopup } from 'js/components/common/Popup';
import LeaveButton from './LeaveButton';
import style from './index.scss';

export const StayButton = ({ toggleLeavePopup, t }) => (
    <Button
        view="primary"
        variant="rounded"
        color="success"
        size="large"
        onClick={toggleLeavePopup}
        className={`${style.button} ${style.stayButton}`}>
        {t('playtech.mobile.system.leaderboard.leaveRace.popup.button.stay')}
    </Button>
);

export const popupClassNames = { inner: style.popupInner };

export default ({ toggleLeavePopup, leaderboardId, t }) => (
    <LocalPopup onClose={toggleLeavePopup}
        className={style.popup}
        classNames={popupClassNames}>
        <div className={style.content}>
            <p className={style.title}>{t('playtech.mobile.system.leaderboard.leaveRace.popup.title')}</p>
            <p>{t('playtech.mobile.system.leaderboard.leaveRace.popup.text')}</p>
        </div>
        <div className={style.actions}>
            <LeaveButton {...{ leaderboardId }} />
            <StayButton {...{ toggleLeavePopup, t }} />
        </div>
    </LocalPopup>
);

